import { Add } from '@mui/icons-material';
import styles from './AddProductCard.module.scss';

const AddProductCard = (props) => {
	const { text, handleClick, className = '' } = props;

	return (
		<div className={`${styles.root} ${className}`} onClick={handleClick}>
			<Add className={`${styles['add-icon']}`} />
			{text}
		</div>
	);
};

export default AddProductCard;
